import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  btnWrap: {
    margin: "10px 0",
    display: "block"
  },
  btnPrimary: {
    background: theme?.palette?.primary2TextColor?.main,
    borderRadius: "10px",
    padding: "6px 20px",
    color: `${theme?.palette?.secondaryText?.[700]} !important`,
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize",
    "&:hover": {
      background: theme?.palette?.primaryBG?.[450],
      color: theme?.palette?.primaryText?.[100]
    }
  },
  btnSecondary: {
    color: theme?.palette?.primaryText?.[100],
    padding: "2px 17px",
    fontSize: "14px",
    background: theme?.palette?.primaryBG?.[400],
    fontWeight: 500,
    borderRadius: "5px",
    textTransform: "capitalize",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.625rem",
      padding: "0.125rem 0.625rem",
      borderRadius: "0.313rem"
    },
    "&:hover": {
      background: theme?.palette?.primary2TextColor?.main,
      color: `${theme?.palette?.secondaryText?.[700]} !important`
    }
  },
  viewAllBtn: {
    position: "relative",
    marginLeft: "10px",
    // zIndex: 10,
    padding: "2px 4px",
    fontSize: "12px",
    borderRadius: "5px",
    height: "24px",
    width: "77px",
    minWidth: "77px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    boxSizing: "border-box"
  },
  categoryTab: {
    textDecoration: "none",
    marginRight: "5px",
    color: theme?.palette?.primaryText?.[100],
    padding: "5px 30px",
    // height: "40px",
    background: theme?.palette?.primaryBG?.[450],
    borderRadius: "30px",
    fontSize: "12px",
    minHeight: "38px",
    "&:hover": {
      background: theme?.palette?.primary2TextColor?.main,
      color: `${theme?.palette?.secondaryText?.[700]} !important`
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      minHeight: "34px",
      padding: "0 20px"
    }
  },
  // bannerContent: {
  //   padding: "30px 0 30px 60px",
  //   "& .MuiTypography-h1": {
  //     fontWeight: "bold",
  //     fontSize: "50px",
  //     fontFamily: "Rammetto One !important",
  //     [theme.breakpoints.down("sm")]: {
  //       fontSize: "35px",
  //     },
  //     "& br": {
  //       [theme.breakpoints.down("sm")]: {
  //         display: "none",
  //       },
  //     },
  //   },
  //   "& img,svg": {
  //     marginRight: "5px",
  //     [theme.breakpoints.down("sm")]: {
  //       marginRight: "0",
  //       width: "100px",
  //     },
  //   },
  //   "& .MuiTypography-body1": {
  //     fontSize: "30px",
  //     [theme.breakpoints.down("sm")]: {
  //       fontSize: "18px",
  //     },
  //   },
  //   "& .MuiButton-textPrimary": {
  //     padding: "6px 40px",
  //     marginTop: "10px",
  //   },
  //   [theme.breakpoints.down("sm")]: {
  //     padding: "30px 15px",
  //   },
  // },
  homeOptions: {
    width: "100%",
    padding: "30px 100px",
    marginRight: "auto",
    marginLeft: "auto",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("lg")]: {
      padding: "30px 10px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px"
    },

    "& .tabsContainer": {
      padding: "5px 0",
      [theme.breakpoints.down("sm")]: {
        width: "100%"
      }
    }
  },
  homeBonusWrap: {
    padding: "20px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
    // "& .MuiTabs-hideScrollbar":{
    //   background:"red",
    // },
  },
  bonusTab: {
    padding: "15px 10px 0 10px",
    margin: "0 10px",
    // minWidth: "300px",

    "& img,svg": {
      width: "100%",
      height: "100%"
    },
    // marginLeft: "30px",
    // marginRight: "50px",
    marginTop: "5px",
    marginBottom: "5px",
    [theme.breakpoints.down("sm")]: {
      width: "50%",
      minWidth: "auto"
    }
  },
  searchfieldWrap: {
    // marginLeft: "102px",
    // marginTop: "20px",
    // backgroundColor: theme?.palette?.primaryBG?.[400],
    // marginRight: "164px",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%"
      // marginTop: "10px",
    },
    "& .MuiFormControl-root": {
      [theme.breakpoints.down("sm")]: {
        width: "100%"
      }
    }
  },
  homeFilter: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 100px",
    marginRight: "auto",
    marginLeft: "auto",
    [theme.breakpoints.down("lg")]: {
      padding: "30px 10px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 15px",
      // overflowX: "auto",
      alignItems: "center",
      flexFlow: "column"
    },
    "& .MuiInputBase-colorPrimary": {
      width: "140px",
      background: theme?.palette?.primaryBG?.[450],
      borderRadius: "5px",
      height: "44px",
      color: theme?.palette?.primaryText?.[100],
      cursor: "pointer",
      [theme.breakpoints.down("md")]: {
        marginRight: "10px",
        width: "100%",
        fontSize: "12px"
      },
      [theme.breakpoints.down("sm")]: {
        marginRight: "0px",
        marginBottom: "10px",
        width: "100%",
        fontSize: "10px"
      }
    },
    "& .MuiInputBase-input": {
      height: "20px",
      padding: "10px",
      fontSize: "14px",
      // background: "#FFCE10",
      color: theme?.palette?.primaryText?.[100],
      borderRadius: "10px",
      cursor: "pointer",

      [theme.breakpoints.down("md")]: {
        width: "100%",
        lineHeight: "20px"
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px",
      borderColor: `${theme?.palette?.secondaryText?.[200]} !important`
    },

    "& .MuiSvgIcon-root": {
      color: theme?.palette?.primaryText?.[100]
    },
    "& .tabsContainer": {
      width: "calc(100% - 260px)",
      background: theme?.palette?.primaryBG?.[400],
      borderRadius: "10px",
      padding: "5px 0",
      margin: "0 10px",
      height: "44px",
      [theme.breakpoints.down("md")]: {
        width: "70%",
        margin: "0 5px"
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        margin: "0 5px"
      }
    }
  },

  contentWrap: {
    // padding: "10px 15px",
    position: "relative",
    marginBottom: "0",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "0px",
      paddingRight: "0px"
    },
    "& .slick-slider": {
      "& .slick-arrow": {
        display: "block !important",
        visibility: "visible !important",
        opacity: "1 !important"
      },
      "& .slick-disabled": {
        opacity: "0.4 !important"
      }
    },
    // height: "225px",
    // padding: "30px 100px",
    // marginTop: "-30px",
    // [theme.breakpoints.down("lg")]: {
    //   padding: "30px 15px",
    // },
    // [theme.breakpoints.down("sm")]: {
    //   padding: "30px 5px",
    // },
    // [theme.breakpoints.down("md")]: {
    //   padding: "30px 15px",
    // },
    "& .gamesOuter": {
      display: "grid",
      // paddingBottom: "20px",
      gridTemplateColumns:
        "repeat(auto-fill,minmax(calc(12.66667% - 8.33333px),1fr))",
      gap: "16px",
      rowGap: "18px",
      [theme.breakpoints.down("xl")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(19.66667% - 8.33333px),1fr))",
        gap: "14px",
        rowGap: "16px"
      },
      [theme.breakpoints.down("lg")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(16.66667% - 8.33333px),1fr))",
        gap: "12px",
        rowGap: "14px"
      },
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(32.66667% - 8.33333px),1fr))",
        gap: "12px",
        rowGap: "14px"
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(32.66667% - 10.33333px),1fr))",
        gap: "16px",
        rowGap: "14px",
        paddingBottom: "0"
      },
      "& a": {
        width: "146px",
        textDecoration: "none",
        borderRadius: "12px",
        // border: "4px solid #FFD700",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "146px",
        [theme.breakpoints.down("sm")]: {
          width: "auto",
          height: "auto"
        },
        background: theme?.palette?.primaryBG?.[400],
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        "& img,svg": {
          width: "100px",
          height: "100px",
          objectFit: "contain"
        }
      }
    },
    "& .slick-list": {
      // marginLeft: "-8px",
      // marginRight: "-8px"
    },

    "& .slick-slide": {
      paddingLeft: "8px",
      paddingRight: "8px"
    }
  },
  contentWrapSuggestion: {
    padding: "15px 10px 40px",
    // height: "225px",
    // padding: "30px 100px",
    // marginTop: "-30px",
    // [theme.breakpoints.down("lg")]: {
    //   padding: "30px 15px",
    // },
    [theme.breakpoints.down("sm")]: {
      padding: "15px 10px"
    },
    // [theme.breakpoints.down("md")]: {
    //   padding: "30px 15px",
    // },
    "& .gamesOuter": {
      display: "grid",
      // paddingBottom: "20px",
      gridTemplateColumns:
        "repeat(auto-fill,minmax(calc(10.66667% - 8.33333px),1fr))",
      gap: "16px",
      rowGap: "18px",
      [theme.breakpoints.down("xl")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(19.66667% - 8.33333px),1fr))",
        gap: "14px",
        rowGap: "16px"
      },
      [theme.breakpoints.down("lg")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(16.66667% - 8.33333px),1fr))",
        gap: "12px",
        rowGap: "14px"
      },
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(32.66667% - 8.33333px),1fr))",
        gap: "12px",
        rowGap: "14px"
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns:
          "repeat(auto-fill,minmax(calc(32.66667% - 8.33333px),1fr))",
        gap: "12px",
        rowGap: "14px",
        paddingBottom: "0"
      },
      "& a": {
        width: "146px",
        height: "146px",
        display: "flex",
        background: theme?.palette?.primaryBG?.[400],
        alignItems: "center",
        borderRadius: "10px",
        justifyContent: "center",
        padding: "10px",
        [theme.breakpoints.down("sm")]: {
          width: "168px",
          height: "168px"
        },
        "& img,svg": {
          width: "100px",
          height: "100px",
          objectFit: "contain"
        }
      }
    },
    "& .slick-track": {
      marginTop: "5px",
      marginLeft: "0px",
      marginRight: "0px"
    }
  },

  casinoCard: {
    height: "auto",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
    // margin: "0 8px",
    // [theme.breakpoints.down("xl")]: {
    //   marginRight: "10px",
    // },
    "& > .imgBox": {
      position: "relative",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      margin: "0 auto",
      // [theme.breakpoints.down("sm")]: {
      //   width: "108px",
      //   height: "108px",
      //   borderRadius: "15px",
      // },
      "&:hover img": {
        transform: "translateY(-6px)" // slightly move up
        // filter: "blur(2px)",
      },
      // "&:hover .playBtnBox": {
      //   opacity: "1"
      // },
      "& img": {
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        // objectFit: "cover",
        objectPosition: "center",
        width: "100%",
        height: "100%",
        transition: "0.3s all ease-in-out"
      },
      "& .squareBox": {
        display: "block",
        paddingTop: "100%",
        [theme.breakpoints.down("sm")]: {
          paddingTop: "78%"
        }
      },
      "& .playBtnBox": {
        width: "100%",
        height: "100%",
        background:
          "linear-gradient(to right, rgb(23 38 41 / 80%) 1%,rgb(24 25 24 / 92%) 99%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: "0",
        transition: "0.3s all ease-in-out",
        position: "absolute",
        top: "0",
        left: "0",
        "& .playBtn": {
          background: "transparent",
          border: "0",
          color: theme?.palette?.primaryText?.[100],
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          "& svg": {
            width: "35px",
            height: "auto",
            marginBottom: "15px",
            fill: theme?.palette?.primary2TextColor?.main,
            [theme.breakpoints.down("sm")]: {
              width: "20px"
            }
          },
          "& .text": {
            fontSize: "0.75rem",
            fontWeight: "600",
            color: theme?.palette?.primaryText?.[100],
            backgroundColor: theme?.palette?.primaryBG?.[400],
            padding: "0.125rem 0.625rem",
            borderRadius: "0.313rem",
            "&:hover": {
              backgroundColor: theme?.palette?.secondaryBG?.main,
              color: theme?.palette?.primaryBG?.[400]
            },
            [theme.breakpoints.down("sm")]: {
              fontSize: "12px"
            }
          }
        }
      }
    },
    // "& img,svg": {
    //   height: "100%",
    //   width: "100%",
    // },
    "& .MuiTypography-body1": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "120px"
      }
    },
    "& .favIconWrap": {
      position: "absolute",
      top: "0px",
      right: "10px",
      zindex: "9999",
      height: "20px",
      width: "20px",
      cursor: "pointer",
      "& img,svg": {
        position: "absolute !important",
        right: "10px !important",
        top: "0px !important",
        transform: "none !important"
      }
    }
  },
  casinoOverlay: {
    marginBottom: "10px",
    marginTop: "10px",
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    "& .MuiTypography-body1": {
      // paddingRight: "10px",
      fontWeight: "500",
      cursor: "pointer",
      wordBreak: "break-word",
      [theme.breakpoints.down("sm")]: {
        display: "none"
      }
    },
    "&:hover": {
      "& > .MuiGrid-root": {
        display: "block"
      }
    }
  },
  infoBtn: {
    background: theme?.palette?.primaryText?.[100],
    borderRadius: "5px",
    padding: "5px",
    cursor: "pointer",
    position: "relative",
    "& img,svg": {
      height: "12px",
      width: "12px",
      [theme.breakpoints.down("sm")]: {
        height: "10px",
        width: "10px"
      }
    },
    [theme.breakpoints.down("sm")]: {
      padding: "2px",
      display: "flex",
      height: "20px",
      alignItems: "center",
      justifyContent: "center"
    }
  },
  customInfoModal: {
    borderRadius: "10px",
    background: theme?.palette?.primaryBG?.[400],
    position: "absolute",
    minWidth: "100%",
    left: "50%",
    right: "auto",
    top: "-60px",
    padding: "0px",
    zIndex: "5",
    display: "none",
    transform: "translate(-50%, -50%)",
    [theme.breakpoints.down("sm")]: {
      left: "50%",
      borderRadius: "2px",
      top: "-40px"
      // minWidth: "auto",
      // transform: "translate(0%, -50%)",
      // top: "0",
    }
  },
  customInfoCard: {
    padding: "3px",
    background: theme?.palette?.primaryBG?.[450],
    margin: "5px",
    borderRadius: "5px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "& span": {
      fontSize: "12px",
      color: theme?.palette?.primaryText?.[400],
      fontWeight: "600",
      paddingRight: "10px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "6px"
      }
    },
    "& .MuiTypography-body1": {
      fontSize: "12px",
      color: theme?.palette?.primaryText?.[100],
      [theme.breakpoints.down("sm")]: {
        fontSize: "6px",
        fontWeight: "600",
        whiteSpace: "unset",
        paddingRight: "0"
      }
    },
    [theme.breakpoints.down("sm")]: {
      borderRadius: "2px"
    }
  },
  innerHeading: {
    display: "flex",
    alignItems: "center",
    margin: "15px 5px",
    [theme.breakpoints.down("sm")]: {
      gap: "15px"
    }
  },
  innerHeadingLeft: {
    // marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginBottom: "0px"
    },
    "& img,svg": {
      marginRight: "0.550rem",
      width: "1.25rem",
      [theme.breakpoints.down("md")]: {
        width: "0.938rem"
      }
    },
    "& .MuiTypography-h6": {
      margin: "0",
      color: theme?.palette?.primaryText?.[100],
      fontFamily: "Poppins",
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "normal",
      display: "flex",
      alignItems: "center",

      [theme.breakpoints.down("md")]: {
        fontSize: "0.85rem"
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.85rem",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxWidth: "190px",
        whiteSpace: "nowrap",
        display: "block"
      }
    },
    "& a": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.625rem",
        padding: "0.125rem 0.625rem",
        borderRadius: "0.313rem"
      }
    }
  },
  noGamesMsg: {
    textAlign: "center"
  },
  categoryLoader: {
    margin: "40px",
    color: theme?.palette?.primary2TextColor?.main
  },
  providerCategorySkeleton: {
    top: "-14px",
    position: "relative"
  },
  providerSection: {
    [theme.breakpoints.down("md")]: {
      overflowX: "auto",
      padding: "0px 0px"
    }
  },
  providerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "30px 100px",
    [theme.breakpoints.down("md")]: {
      overflowX: "auto",
      padding: "30px 10px",
      justifyContent: "flex-start"
    }
  },
  providerCard: {
    padding: "10px",
    background: theme?.palette?.primaryBG?.[400],
    borderRadius: "10px",
    margin: "0 10px",
    "& img,svg": {
      height: "60px",
      width: "100%"
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "200px"
    }
  },
  heartIcon: {
    width: "20px !important",
    height: "24px !important",
    minWidth: "22px !important",
    marginRight: "12px",
    display: "inline-block !important",
    flexShrink: 0,
    verticalAlign: "middle",
    opacity: "1 !important",
    visibility: "visible !important",
    pointerEvents: "auto !important",
    "& path, & g, & circle, & rect, & polygon": {
      fill: `${theme?.palette?.primary2TextColor?.main} !important`,
      opacity: "1 !important",
      visibility: "visible !important"
    },
    "& svg": {
      width: "18px !important",
      height: "18px !important",
      display: "block !important",
      opacity: "1 !important",
      visibility: "visible !important"
    },
    [theme.breakpoints.down("sm")]: {
      width: "22px !important",
      height: "22px !important",
      minWidth: "22px !important",
      marginRight: "8px",
      "& svg": {
        width: "22px !important",
        height: "22px !important"
      }
    }
  },

  innerHeadingLeftText: {
    marginRight: "20px"
  },
  favIconWrap: {
    position: "absolute",
    top: "10px",
    right: "10px",
    minWidth: "20px",
    padding: "0",
    minHeight: "auto !important",
    zIndex: "1",
    height: "20px",
    width: "auto !important",
    cursor: "pointer",
    "& img,svg": {
      transform: "none !important"
    }
  },
  modalFavBtn: {
    // margin: "0 8px",
    position: "absolute",
    top: "10px",
    right: "10px",
    zIndex: "9",
    [theme.breakpoints.down("sm")]: {
      zIndex: "1",
      position: "relative",
      top: "10px",
      right: "10px",
      "& img,svg": {
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        // objectFit: "cover",
        objectPosition: "center",
        width: "100%",
        height: "100%",
        transition: "0.3s all ease-in-out"
      }
    },
    "& .MuiButtonBase-root ": {
      "& img,svg": {
        width: "22px",
        right: "0",
        left: "inherit",
        height: "22px"
      }
    },
    "& button": {
      width: "100%"
    }
  },
  bannerLoader: {
    height: "200px",
    margin: "20px 0",
    padding: "0 100px",
    [theme.breakpoints.down("lg")]: {
      padding: "0 15px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 26px",
      height: "100px",
      marginBottom: "0px"
    },

    "& span": {
      display: "block",
      height: "100%",
      [theme.breakpoints.down("sm")]: {
        height: "60%"
      },
      borderRadius: "10px"
    }
  },

  arrowbutton: {
    position: "absolute",
    top: "-30px",
    right: "30px !important",
    transform: "translate(-50%, -50%)",
    "& .slick-next:before": {
      display: "none"
    },
    "& button": {
      borderRadius: "10px",
      background: theme?.palette?.primaryBG?.[400],
      minWidth: "38px",
      padding: "8px 8px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "28px"
      },
      "&:hover": {
        borderRadius: "10px",
        background: theme?.palette?.primaryBG?.[400],
        // minWidth: "38px",
        padding: "13px 8px"
      },
      "& svg": {
        "&.active": {
          color: theme?.palette?.primary2TextColor?.main
        },
        "&.inactive": {
          color: theme?.palette?.primary2TextColor?.main,
          opacity: "0.4"
        }
      }
    },
    [theme.breakpoints.down("sm")]: {
      top: "-20px"
    }
  },
  leftArrow: {
    right: "30px !important",
    [theme.breakpoints.down("sm")]: {
      right: "30px !important"
    }
  },
  rightArrow: {
    right: "-18px !important",
    [theme.breakpoints.down("sm")]: {
      right: "-10px !important"
    }
  },

  providerwrap: {
    background: theme?.palette?.primaryBG?.[400],
    borderRadius: "20px 20px 0 0",
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    marginLeft: "89px",
    width: "150px",
    "& img,svg": {
      marginRight: "5px",
      width: "20px",
      [theme.breakpoints.down("md")]: {
        width: "15px"
      }
    },
    "& .MuiTypography-h6": {
      margin: "0",
      color: theme?.palette?.primaryText?.[100],
      fontWeight: "600",
      fontSize: "16px",
      [theme.breakpoints.down("md")]: {
        fontSize: "16px"
      }
    }
  },

  sliderPrev: {
    marginLeft: "1100px",
    marginTop: "-6px"
  },
  sliderNext: {
    marginLeft: "1141px",
    marginTop: "-301px"
  },

  searchprovider: {
    width: "100%"
  },
 providrsearchwrap: {
  width: "100%",
  display: "flex",
  gap: "15px",
  marginTop: "16px",
  alignItems: "center",

  "& .MuiOutlinedInput-root": {
    height: "42px",
    borderRadius: "10px",
    backgroundColor: theme?.palette?.primaryBG?.[400],
  },

  "& .MuiInputBase-input": {
    height: "42px",
    padding: "0 12px", // no vertical padding
    boxSizing: "border-box",
    color: theme?.palette?.primaryText?.[100],
    lineHeight: "42px"
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiOutlinedInput-root": {
      height: "38px"
    },
    "& .MuiInputBase-input": {
      height: "38px",
      padding: "0 10px",
      fontSize: "14px",
      lineHeight: "38px"
    }
  }
},

  searchIcon: {
  width: "42px",
  height: "42px",
  borderRadius: "10px",
  background: "#0A2024",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& svg, & img": {
    width: "18px",
    height: "18px"
  },

  [theme.breakpoints.down("sm")]: {
    width: "38px",
    height: "38px"
  }
},
  CircularProgress: {
    color: theme?.palette?.primary2TextColor?.main
  },
  favImg: {
    width: "25px",
    right: "0"
  },
  providerWrapper: {
    marginBottom: "100px",
    marginTop: "20px"
  },
  liveProvidersWrap: {
    // justifyContent: "space-between"
  },
  providerImgBtn: {
    background: theme?.palette?.primaryBG?.[450],
    width: "100%",
    paddingBottom: "95%",
    position: "relative",
    borderRadius: "0.625rem",
    marginTop: "0.625rem",

    "&.MuiButton-root": {
      "&:hover": {
        background: theme?.palette?.primaryBG?.[450]
      }
    },
    "& img,svg": {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100%",
      // height: "100%",
      borderRadius: "0.625rem"
    }
  },
  lazyload: {
    // [theme.breakpoints.down("sm")]: {
    //   height: "150px"
    // },
    // [theme.breakpoints.down("md")]: {
    //   height: "150px"
    // },
    [theme.breakpoints.down("lg")]: {
      height: "200px"
    },
    [theme.breakpoints.up("lg")]: {
      height: "230px"
    }
  },
  lazyloadMobile: {
    height: "150px"
  },
  skeletonStyle: {
    height: "100%",
    width: "100%",
    opacity: "0"
  },
  fill: {
    color: theme?.palette?.primary2TextColor?.main
  },
  notfill: {
    color: theme?.palette?.primaryText?.[100]
  },
  myclass: {
    paddingTop: "0",
    paddingLeft: "0",
    paddingRight: "0px",
    marginTop: "0",
    maxWidth: "100%",
    // overflowX: "hidden",
    [theme.breakpoints.down("md")]: {
      // paddingLeft: "10px",
      // paddingRight: "10px"
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0"
      // marginLeft: "10px",
      // paddingLeft: "10px",
      // paddingRight: "10px"
    }
  },
  // Filtered Games Grid View
  gamesGrid: {
    marginTop: "16px",
    paddingLeft: "5px !important",
    marginBottom: "15px !important",
    display: "grid !important",
    gridTemplateColumns: "repeat(7, 1fr) !important",
    gap: "10px !important",
    width: "100%",
    boxSizing: "border-box !important",
    "& .MuiGrid-item": {
      padding: "0 !important",
      width: "100% !important",
      maxWidth: "100% !important",
      aspectRatio: "1 / 1",
      "& > div": {
        width: "100%",
        height: "100%"
      }
    },
    [theme.breakpoints.down("xl")]: {
      gridTemplateColumns: "repeat(7, 1fr) !important"
    },
    [theme.breakpoints.down("lg")]: {
      gridTemplateColumns: "repeat(6, 1fr) !important",
      gap: "8px !important"
    },
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(5, 1fr) !important"
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(3, 1fr) !important",
      // marginLeft: "4px !important",
      gap: "8px !important"
    },
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "repeat(3, 1fr) !important"
    }
  },
  summarySection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "25px",
    marginTop: "10px"
  },
  summaryText: {
    color: `${theme?.palette?.primaryText?.[300]} !important`,
    fontSize: "14px !important",
    fontWeight: "700 !important",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px !important"
    }
  },
  loadMoreSection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "50px",
    marginTop: "20px"
  },
  loadMoreButton: {
    backgroundColor: `${theme?.palette?.primaryBG?.[450]} !important`,
    color: `${theme?.palette?.primaryText?.[100]} !important`,
    borderRadius: "10px !important",
    padding: "12px 50px !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "capitalize !important",
    border: "none !important",
    boxShadow: "none !important",
    transition: "all 0.3s ease !important",
    height: "48px !important",
    minHeight: "48px !important",
    "&:hover": {
      backgroundColor: `${theme?.palette?.primary2TextColor?.main} !important`,
      color: `${theme?.palette?.secondaryText?.[700]} !important`,
      boxShadow: "none !important",
      transform: "translateY(-2px)"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px !important",
      padding: "10px 40px !important",
      height: "44px !important",
      minHeight: "44px !important"
    }
  },
  noGamesText: {
    textAlign: "center",
    color: theme?.palette?.primaryText?.[100],
    fontSize: "16px",
    fontWeight: "500",
    padding: "40px 0",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "30px 0"
    }
  },
  // Featured Games Section
  featuredSection: {
    width: "100%",
    overflow: "visible",
    paddingRight: "0px",
    paddingLeft: "0px",
    [theme.breakpoints.down("md")]: {
      paddingRight: "0px",
      paddingLeft: "0px"
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: "0px",
      paddingLeft: "0px",
      marginBottom: "20px",
      marginTop: "10px"
    }
  },
  featuredSlider: {
    width: "100%"
  },
  featuredGameSliderItem: {
    width: "100%",
    padding: "0 !important"
  },
  featuredMobileSlider: {
    width: "100%",
    "& .slick-track": {
      display: "flex",
      gap: "8px"
    },
    "& .slick-slide": {
      padding: "0 4px"
    }
  },
  featuredGameMobileItem: {
    display: "flex",
    justifyContent: "center",
    padding: "0 4px !important"
  },
  featuredGamesContainer: {
    width: "100%"
  },
  featuredGamesGrid: {
    width: "100%",
    margin: "0 !important",
    "& > .MuiGrid-item": {
      paddingLeft: "8px !important",
      paddingRight: "8px !important"
    },
    [theme.breakpoints.down("sm")]: {
      "& > .MuiGrid-item": {
        paddingLeft: "4px !important",
        paddingRight: "4px !important"
      }
    }
  },
  featuredGameItemWrapper: {
    display: "flex",
    justifyContent: "center"
  },
  featuredGameItemContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)"
    }
  },
  featuredGameCardWrapper: {
    width: "100%",
    height: "auto",
    // maxWidth: "416px",
    maxHeight: "240px",
    backgroundColor: "#0A2024",
    borderRadius: "10px",
    paddingTop: "16px",
    paddingRight: "16px",
    paddingBottom: "8px",
    paddingLeft: "16px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)"
    },
    [theme.breakpoints.down(1800)]: {
      maxHeight: "200px",
      maxWidth: "416px"
    },
    [theme.breakpoints.down(1500)]: {
      maxHeight: "240px"
      // maxWidth: "416px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: "16px",
      paddingRight: "16px",
      paddingBottom: "8px",
      paddingLeft: "16px"
    }
  },
  featuredGameImageWrapper: {
    position: "relative",
    width: "100%",
    objectFit: "fill",
    aspectRatio: "380 / 187",
    overflow: "hidden",
    borderRadius: "15px",
    border: "2px solid transparent",
    backgroundImage:
      "linear-gradient(#230E2F, #230E2F), linear-gradient(180deg, #FF014D 0%, #12494E 80%)",
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px"
    }
  },
  featuredGameImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "center",
    objectPosition: "center"
  },
  featuredGameInfoSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 8px",
    width: "100%",
    boxSizing: "border-box"
  },
  featuredGameName: {
    color: "#FFFFFF",
    fontWeight: "700",
    fontSize: "14px",
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  featuredGameBadgeContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0
  },
  featuredFireIcon: {
    fontSize: "10px",
    width: "10px",
    height: "10px",
    color: "#B0B0B0",
    flexShrink: 0,
    "& svg": {
      width: "100%",
      height: "100%"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      width: "10px",
      height: "10px"
    }
  },
  featuredGameBadge: {
    color: "#B0B0B0",
    fontSize: "10px",
    fontWeight: "700",
    whiteSpace: "nowrap",
    letterSpacing: "0.2px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px"
    }
  },
  featuredGameCardBg: {
    width: "100%",
    backgroundColor: theme?.palette?.primaryBG?.[500],
    padding: "4px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  featuredGameOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "80px",
    background:
      "linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.6) 70%, rgba(0, 0, 0, 0) 100%)",
    zIndex: 2
  },
  featuredGameInfoOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "80px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: "0 16px 12px 16px",
    zIndex: 3,
    width: "100%"
  },
  featuredGameItem: {
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px"
    }
  },
  featuredGameInfo: {
    padding: "10px 0",
    textAlign: "center"
  },
  featuredGameTag: {
    color: theme?.palette?.secondaryText?.[500],
    fontSize: "12px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px"
    }
  }
}));
